/**
 * Farm 88 Days Calculator
 * Calcul des 88 jours de travail agricole pour le WHV Australie
 */

document.addEventListener('DOMContentLoaded', function() {
  // Constants
  const HOURS_PER_DAY = 7.6;
  const TARGET_DAYS = 88;
  
  // DOM Elements
  const entries = document.getElementById('entries');
  const template = document.querySelector('.week-entry.template');
  const addBtn = document.getElementById('add-week');
  const totalHoursEl = document.getElementById('total-hours');
  const totalDaysEl = document.getElementById('total-days');
  const remainingDaysEl = document.getElementById('remaining-days');
  const progressPercentEl = document.getElementById('progress-percent');
  const progressCircleFill = document.getElementById('progress-circle-fill');
  const completionMsg = document.getElementById('completion-msg');
  const downloadBtn = document.getElementById('download-pdf');
  const saveBtn = document.getElementById('save-data');
  
  // Week counter
  let weekCount = 0;
  
  /**
   * Smooth scroll for navigation links
   */
  document.querySelectorAll('.nav-links a').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 70,
          behavior: 'smooth'
        });
      }
    });
  });
  
  /**
   * FAQ Functionality
   */
  document.querySelectorAll('.faq-question').forEach(function(question) {
    question.addEventListener('click', function() {
      const parent = this.parentElement;
      const answer = this.nextElementSibling;
      const isActive = parent.classList.contains('faq-active');
      
      // Close all FAQs
      document.querySelectorAll('.faq-item').forEach(item => {
        item.classList.remove('faq-active');
      });
      document.querySelectorAll('.faq-answer').forEach(ans => {
        ans.style.display = 'none';
      });
      
      // Open clicked FAQ if it wasn't already open
      if (!isActive) {
        parent.classList.add('faq-active');
        answer.style.display = 'block';
      }
    });
  });
  
  /**
   * Calculate total hours and days from all entries
   */
  function calculateTotals() {
    let totalHours = 0;
    
    // Sum all hours
    document.querySelectorAll('#entries .entry-hours').forEach(input => {
      const hours = parseFloat(input.value) || 0;
      totalHours += hours;
    });
    
    // Calculate days
    const totalDays = Math.floor(totalHours / HOURS_PER_DAY);
    const cappedDays = Math.min(totalDays, TARGET_DAYS);
    const remaining = Math.max(TARGET_DAYS - cappedDays, 0);
    const percentage = Math.round((cappedDays / TARGET_DAYS) * 100);
    
    // Update UI
    totalHoursEl.textContent = totalHours.toFixed(1);
    totalDaysEl.textContent = cappedDays;
    remainingDaysEl.textContent = remaining;
    progressPercentEl.textContent = percentage + '%';
    
    // Update progress circle
    const circumference = 2 * Math.PI * 90; // radius = 90
    const offset = circumference - (percentage / 100) * circumference;
    progressCircleFill.style.strokeDashoffset = offset;
    
    // Show/hide completion message
    completionMsg.style.display = cappedDays >= TARGET_DAYS ? 'block' : 'none';
    
    // Update individual week days display
    updateWeekDaysDisplay();
    
    // Save to localStorage
    saveDataToLocalStorage();
  }
  
  /**
   * Update the days display for each week entry
   */
  function updateWeekDaysDisplay() {
    document.querySelectorAll('#entries .week-entry').forEach(entry => {
      const hoursInput = entry.querySelector('.entry-hours');
      const daysValue = entry.querySelector('.days-value');
      const hours = parseFloat(hoursInput.value) || 0;
      const days = (hours / HOURS_PER_DAY).toFixed(1);
      daysValue.textContent = days;
    });
  }
  
  /**
   * Add a new week entry
   */
  function addWeekEntry(date = '', hours = '') {
    weekCount++;
    
    // Clone template
    const clone = template.cloneNode(true);
    clone.classList.remove('template');
    clone.style.display = 'flex';
    
    // Set week number
    const weekNumber = clone.querySelector('.week-number');
    weekNumber.textContent = `Semaine ${weekCount}`;
    
    // Get elements
    const dateInput = clone.querySelector('.entry-date');
    const hoursInput = clone.querySelector('.entry-hours');
    const removeBtn = clone.querySelector('.remove-week');
    
    // Set values if provided
    if (date) dateInput.value = date;
    if (hours) hoursInput.value = hours;
    
    // Add event listeners
    hoursInput.addEventListener('input', calculateTotals);
    dateInput.addEventListener('change', saveDataToLocalStorage);
    
    hoursInput.addEventListener('input', function() {
      // Animate the entry on input
      clone.style.transform = 'scale(1.02)';
      setTimeout(() => {
        clone.style.transform = 'scale(1)';
      }, 200);
    });
    
    removeBtn.addEventListener('click', function() {
      // Animate removal
      clone.style.opacity = '0';
      clone.style.transform = 'translateX(-20px)';
      setTimeout(() => {
        clone.remove();
        updateWeekNumbers();
        calculateTotals();
      }, 300);
    });
    
    // Add to DOM with animation
    clone.style.opacity = '0';
    clone.style.transform = 'translateY(20px)';
    entries.appendChild(clone);
    
    // Trigger animation
    setTimeout(() => {
      clone.style.transition = 'all 0.3s ease';
      clone.style.opacity = '1';
      clone.style.transform = 'translateY(0)';
    }, 10);
    
    // Focus on hours input if empty
    if (!hours) {
      hoursInput.focus();
    }
    
    // Calculate totals if values were provided
    if (hours) {
      calculateTotals();
    }
  }
  
  /**
   * Update week numbers after deletion
   */
  function updateWeekNumbers() {
    weekCount = 0;
    document.querySelectorAll('#entries .week-entry').forEach(entry => {
      weekCount++;
      const weekNumber = entry.querySelector('.week-number');
      weekNumber.textContent = `Semaine ${weekCount}`;
    });
  }
  
  /**
   * Save data to localStorage
   */
  function saveDataToLocalStorage() {
    const data = [];
    document.querySelectorAll('#entries .week-entry').forEach(entry => {
      const date = entry.querySelector('.entry-date').value;
      const hours = entry.querySelector('.entry-hours').value;
      if (hours) {
        data.push({ date, hours });
      }
    });
    
    // Save as JSON
    try {
      const jsonData = JSON.stringify(data);
      // Create a timestamp
      const timestamp = new Date().toISOString();
      
      // Create save object
      const saveObject = {
        data: data,
        timestamp: timestamp,
        version: '1.0'
      };
      
      // For now, we'll just prepare the data
      // In a real implementation, this could be saved to localStorage
      // But as per requirements, we're not using browser storage
      console.log('Data prepared for save:', saveObject);
    } catch (error) {
      console.error('Error preparing data:', error);
    }
  }
  
  /**
   * Generate PDF summary
   */
  function generatePDF() {
    const { jsPDF } = window.jspdf;
    if (!jsPDF) {
      alert('Erreur : la bibliothèque PDF n\'est pas chargée. Veuillez rafraîchir la page.');
      return;
    }
    
    const doc = new jsPDF();
    
    // Set font
    doc.setFont('helvetica');
    
    // Add logo/header background
    doc.setFillColor(224, 84, 36);
    doc.rect(0, 0, 210, 40, 'F');
    
    // Header
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(24);
    doc.setFont(undefined, 'bold');
    doc.text('Résumé 88 Jours Agricoles', 105, 20, { align: 'center' });
    
    doc.setFontSize(12);
    doc.setFont(undefined, 'normal');
    doc.text('Working Holiday Visa - Australie', 105, 30, { align: 'center' });
    
    // Reset text color
    doc.setTextColor(0, 0, 0);
    
    // Date of generation
    doc.setFontSize(10);
    const today = new Date().toLocaleDateString('fr-FR', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
    doc.text(`Généré le ${today}`, 105, 50, { align: 'center' });
    
    // Summary box
    doc.setFillColor(240, 249, 255);
    doc.roundedRect(20, 60, 170, 35, 3, 3, 'F');
    
    // Summary content
    const totalHours = totalHoursEl.textContent;
    const totalDays = totalDaysEl.textContent;
    const percentage = progressPercentEl.textContent;
    const remaining = remainingDaysEl.textContent;
    
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text(`Progression : ${percentage}`, 105, 75, { align: 'center' });
    
    doc.setFontSize(12);
    doc.setFont(undefined, 'normal');
    doc.text(`Total : ${totalHours} heures = ${totalDays} jours validés`, 105, 85, { align: 'center' });
    
    // Progress bar
    doc.setDrawColor(224, 84, 36);
    doc.setLineWidth(0.5);
    doc.rect(20, 100, 170, 10);
    
    const progressWidth = (parseInt(totalDays) / TARGET_DAYS) * 170;
    doc.setFillColor(6, 214, 160);
    doc.rect(20, 100, Math.min(progressWidth, 170), 10, 'F');
    
    doc.setFontSize(10);
    doc.text(`${totalDays} / ${TARGET_DAYS} jours`, 105, 120, { align: 'center' });
    
    // Table header
    let y = 135;
    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.text('Détail des semaines travaillées', 20, y);
    
    y += 10;
    doc.setFillColor(245, 245, 245);
    doc.rect(20, y - 5, 170, 10, 'F');
    
    doc.setFont(undefined, 'bold');
    doc.text('Semaine', 25, y + 2);
    doc.text('Date', 65, y + 2);
    doc.text('Heures', 120, y + 2);
    doc.text('Jours', 160, y + 2);
    
    // Draw line
    y += 7;
    doc.setLineWidth(0.5);
    doc.line(20, y, 190, y);
    
    // Table content
    y += 8;
    doc.setFont(undefined, 'normal');
    doc.setFontSize(11);
    
    let weekNum = 0;
    let hasData = false;
    
    document.querySelectorAll('#entries .week-entry').forEach((entry, index) => {
      const hours = parseFloat(entry.querySelector('.entry-hours').value) || 0;
      if (hours > 0) {
        hasData = true;
        weekNum++;
        const date = entry.querySelector('.entry-date').value || 'Non spécifiée';
        const days = (hours / HOURS_PER_DAY).toFixed(1);
        
        // Alternate row background
        if (weekNum % 2 === 0) {
          doc.setFillColor(250, 250, 250);
          doc.rect(20, y - 5, 170, 8, 'F');
        }
        
        doc.text(`Semaine ${weekNum}`, 25, y);
        doc.text(date, 65, y);
        doc.text(hours.toFixed(1), 120, y);
        doc.text(days, 160, y);
        
        y += 10;
        
        // New page if needed
        if (y > 270) {
          doc.addPage();
          y = 20;
        }
      }
    });
    
    if (!hasData) {
      doc.text('Aucune donnée saisie', 105, y, { align: 'center' });
      y += 10;
    }
    
    // Summary at bottom
    if (y < 230) {
      y = 230;
    }
    
    doc.setFillColor(224, 84, 36);
    doc.rect(0, y, 210, 40, 'F');
    
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(12);
    
    const status = parseInt(totalDays) >= TARGET_DAYS 
      ? '✓ Objectif atteint ! Tu peux demander ton second WHV !' 
      : `Il te reste ${remaining} jours à travailler`;
    
    doc.text(status, 105, y + 15, { align: 'center' });
    
    doc.setFontSize(10);
    doc.setFont(undefined, 'italic');
    doc.text('Document généré par le Calculateur 88 Jours - My Little France', 105, y + 25, { align: 'center' });
    
    // Save
    const fileName = `88_jours_whv_${new Date().toISOString().slice(0, 10)}.pdf`;
    doc.save(fileName);
  }
  
  /**
   * Save data handler
   */
  function handleSaveData() {
    const data = [];
    document.querySelectorAll('#entries .week-entry').forEach(entry => {
      const date = entry.querySelector('.entry-date').value;
      const hours = entry.querySelector('.entry-hours').value;
      if (hours) {
        data.push({ date, hours });
      }
    });
    
    // Create a text file content
    let content = 'Calculateur 88 Jours - Données sauvegardées\n';
    content += '==========================================\n\n';
    content += `Date de sauvegarde : ${new Date().toLocaleString('fr-FR')}\n\n`;
    content += `Total des heures : ${totalHoursEl.textContent}h\n`;
    content += `Jours validés : ${totalDaysEl.textContent} / ${TARGET_DAYS}\n`;
    content += `Progression : ${progressPercentEl.textContent}\n\n`;
    content += 'Détail des semaines :\n';
    content += '-------------------\n';
    
    data.forEach((week, index) => {
      const days = (parseFloat(week.hours) / HOURS_PER_DAY).toFixed(1);
      content += `Semaine ${index + 1} : ${week.date || 'Sans date'} - ${week.hours}h (${days} jours)\n`;
    });
    
    // Create blob and download
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `88_jours_donnees_${new Date().toISOString().slice(0, 10)}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    // Show confirmation
    const btn = document.getElementById('save-data');
    const originalText = btn.innerHTML;
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" fill="currentColor"/></svg> Données sauvegardées !';
    btn.style.backgroundColor = '#06D6A0';
    btn.style.borderColor = '#06D6A0';
    btn.style.color = 'white';
    
    setTimeout(() => {
      btn.innerHTML = originalText;
      btn.style.backgroundColor = '';
      btn.style.borderColor = '';
      btn.style.color = '';
    }, 3000);
  }
  
  /**
   * Initialize
   */
  function init() {
    // Add button event
    addBtn.addEventListener('click', () => addWeekEntry());
    
    // Download button event
    downloadBtn.addEventListener('click', generatePDF);
    
    // Save button event
    saveBtn.addEventListener('click', handleSaveData);
    
    // Add initial week
    addWeekEntry();
    
    // Initialize progress circle
    const circumference = 2 * Math.PI * 90;
    progressCircleFill.style.strokeDasharray = circumference;
    progressCircleFill.style.strokeDashoffset = circumference;
    
    // Run initial calculation
    calculateTotals();
  }
  
  // Initialize the app
  init();
  
  /**
   * Unit Tests (console output)
   */
  function runTests() {
    console.group('🧪 Tests unitaires - Calculateur 88 jours');
    
    // Test 1: Basic conversion
    console.assert(
      Math.floor(7.6 / HOURS_PER_DAY) === 1,
      '✓ Test 1: 7.6h = 1 jour'
    );
    
    // Test 2: Target days
    console.assert(
      Math.floor(668.8 / HOURS_PER_DAY) === 88,
      '✓ Test 2: 668.8h = 88 jours'
    );
    
    // Test 3: Zero hours
    console.assert(
      Math.floor(0 / HOURS_PER_DAY) === 0,
      '✓ Test 3: 0h = 0 jour'
    );
    
    // Test 4: Decimal hours
    console.assert(
      Math.floor(38.5 / HOURS_PER_DAY) === 5,
      '✓ Test 4: 38.5h = 5 jours'
    );
    
    // Test 5: Over target
    console.assert(
      Math.min(Math.floor(800 / HOURS_PER_DAY), TARGET_DAYS) === 88,
      '✓ Test 5: Maximum plafonné à 88 jours'
    );
    
    // Test 6: Week calculation
    console.assert(
      Math.floor(38 / HOURS_PER_DAY) === 5,
      '✓ Test 6: 38h (semaine standard) = 5 jours'
    );
    
    console.log('✅ Tous les tests sont passés !');
    console.groupEnd();
  }
  
  // Run tests in development
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    runTests();
  }
  
  // Expose functions for debugging
  window.farm88Debug = {
    calculateTotals,
    addWeekEntry,
    generatePDF,
    runTests,
    saveDataToLocalStorage,
    handleSaveData
  };
});